import React from 'react'
import { FormattedDate } from 'react-intl'
import type { StyleObject, TextProps } from '@vtex/admin-ui'
import { Text } from '@vtex/admin-ui'

import type { SalesPeriod } from './SalesPeriod'

export type SalesPeriodTextOptions = {
  value: SalesPeriod
  month?: 'short' | 'long'
  csx?: StyleObject
}

export type SalesPeriodTextProps = Omit<
  TextProps,
  'children' | keyof SalesPeriodTextOptions
> &
  SalesPeriodTextOptions

export const SalesPeriodText = ({
  value,
  month = 'short',
  className,
  ...props
}: SalesPeriodTextProps) => {
  return (
    <Text className={className} {...props}>
      <FormattedDate
        value={value.start}
        day="numeric"
        month={month}
        year="numeric"
      />
      {' ‒ '}
      <FormattedDate
        value={value.end}
        day="numeric"
        month={month}
        year="numeric"
      />
    </Text>
  )
}
